/**
 * This element is created and injected into the scrollable inner container
 * so it can stretch and match the width and height, effectively getting "free"
 * scrolling, rather than us trying to position elements and match them on scroll
 * and introducing a rubber band.
 */
export const SELECTIONS_CONTAINER_ELEMENT_ID = 'selections-overlay-container';

/**
 * The element that represents the current focus and is drawn on top of the associated
 * cell.
 */
export const SELECTIONS_FOCUS_BOX_ELEMENT_ID = 'selections-focus-box';
/**
 * This element is the main container that we base our highlights off of.
 * For highlights, we inject a container and match the size, allow pointer events
 * to passthrough, etc. When this is not mounted, we cannot have our machine running.
 */
export const SCROLLABLE_INNER_CONTAINER_ID = 'scrollable-inner-container';

/**
 * The main react application. This is used to listen to for mounting
 * highlights when the app is ready.
 */
export const APP_ELEMENT_ID = 'app';

/**
 * Class added to the scroll container when a highlight is visible.
 * Used by CSS to hide hover elements (add row/column dots).
 */
export const HAS_ACTIVE_HIGHLIGHT_CLASS = 'has-active-highlight';

/**
 * Class added to the selections container when a delete intent is active.
 * Used by CSS to override highlight colors to danger/red.
 */
export const HIGHLIGHT_DELETE_INTENT_CLASS = 'highlight-delete-intent';

/**
 * Class added to each selection highlight element for CSS targeting.
 * Does not apply to the focus box.
 */
export const SELECTION_HIGHLIGHT_CLASS = 'selection-highlight';
